import React, { useRef, useState, useEffect } from "react";
import {
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  Input,
  Button,
  Flex,
  Text,
  useToast,
} from "@chakra-ui/react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useDispatch, useSelector } from "react-redux";
import { setGuestName } from "../../Features/guestSlice";
import { DefaultDrawerContent } from "../Component/DefaultDrawerContent";
import { PropertyDrawerContent } from "../Component/PropertyDrawerContent";

export const UserReservationDrawer = ({
  isOpen,
  onClose,
  firstName,
  setFirstName,
  lastName,
  setLastName,
  setSelectedDate,
  selectedDate,
  handleSearch,
  setGuest
}) => {
  const dispatch = useDispatch();
  const toast = useToast();
  const dateInputRef = useRef(null);
  const propertyId = useSelector((state) => state.room.propertyId);
  const [checkInDate, setCheckInDate] = useState(null);
  const [checkOutDate, setCheckOutDate] = useState(null);
  const roomBookings = useSelector((state) => state.room.roomBookings);

  const handleDateInputFocus = () => {
    dateInputRef.current?.setOpen(true);
  };

  const handleFirstNameChange = (e) => {
    const value = e.target.value;
    setFirstName(value);
    localStorage.setItem("reservationFirstName", value);
    dispatch(setGuestName(`${value} ${lastName}`));
  };

  const handleLastNameChange = (e) => {
    const value = e.target.value;
    setLastName(value);
    localStorage.setItem("reservationLastName", value);
    dispatch(setGuestName(`${firstName} ${value}`));
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const handleCheckInChange = (date) => {
    setCheckInDate(date);
    if (checkOutDate && date > checkOutDate) {
      setCheckOutDate(null);
    }
    // Store check-in date in localStorage
    localStorage.setItem('propertyCheckInDate', date ? date.toISOString() : '');
  };

  const handleCheckOutChange = (date) => {
    setCheckOutDate(date);
    // Store check-out date in localStorage
    localStorage.setItem('propertyCheckOutDate', date ? date.toISOString() : '');
  };

  // Initialize dates from localStorage on component mount
  useEffect(() => {
    const savedCheckIn = localStorage.getItem('propertyCheckInDate');
    const savedCheckOut = localStorage.getItem('propertyCheckOutDate');
    
    if (savedCheckIn) {
      setCheckInDate(new Date(savedCheckIn));
    }
    if (savedCheckOut) {
      setCheckOutDate(new Date(savedCheckOut));
    }
  }, []);

  const handleSearchClick = () => {
    if (propertyId) {
      if (!checkInDate || !checkOutDate) {
        toast({
          title: "Missing Dates",
          description: "Please select both check-in and check-out dates",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
        return;
      }

      // Format dates to compare with API response
      const searchCheckIn = checkInDate.toISOString().split('T')[0];
      const searchCheckOut = checkOutDate.toISOString().split('T')[0];



      // Ensure roomBookings is an array before using find
      const bookingsArray = Array.isArray(roomBookings) ? roomBookings : [];

      // Find matching booking from roomBookings
      const matchingBooking = bookingsArray.find(booking => {
        const bookingItem = booking.Bookings?.items?.[0];
        if (!bookingItem) return false;

        // console.log('Comparing with booking:', {
        //   bookingCheckIn: bookingItem.checkInDate,
        //   bookingCheckOut: bookingItem.checkOutDate,
        //   matches: bookingItem.checkInDate === searchCheckIn && bookingItem.checkOutDate === searchCheckOut
        // });

        return bookingItem.checkInDate === searchCheckIn && 
               bookingItem.checkOutDate === searchCheckOut;
      });

      if (matchingBooking) {
        console.log('Found matching booking:', matchingBooking);
        // Directly set the guest information
        setGuest(matchingBooking);
      } else {
        console.log('No matching booking found for dates:', { searchCheckIn, searchCheckOut });
        toast({
          title: "No Booking Found",
          description: "No booking found for the selected dates",
          status: "warning",
          duration: 5000,
          isClosable: true,
        });
        return;
      }
    } else {
      // Handle regular search
      handleSearch();
    }
    onClose();
  };

  return (
    <Drawer
      isOpen={isOpen}
      placement="bottom"
      onClose={onClose}
      closeOnOverlayClick={true}
    >
      <DrawerOverlay />
      {propertyId ? (
        <PropertyDrawerContent
          checkInDate={checkInDate}
          checkOutDate={checkOutDate}
          handleCheckInChange={handleCheckInChange}
          handleCheckOutChange={handleCheckOutChange}
          handleSearchClick={handleSearchClick}
        />
      ) : (
        <DefaultDrawerContent
          firstName={firstName}
          lastName={lastName}
          selectedDate={selectedDate}
          handleFirstNameChange={handleFirstNameChange}
          handleLastNameChange={handleLastNameChange}
          handleDateChange={handleDateChange}
          handleDateInputFocus={handleDateInputFocus}
          dateInputRef={dateInputRef}
          handleSearchClick={handleSearchClick}
          setFirstName={setFirstName}
          setLastName={setLastName}
          setSelectedDate={setSelectedDate}
        />
      )}
    </Drawer>
  );
};
